<div class="newbgcolor">
  <div class="row mx-0">
    <div class="col">
      <div class="formbox flex-column">
        <div class="wccard">
            <p class="f-20 font-weight-600 text-black mb-4">Sign In</p>
            <p class="f-14 font-weight-normal text-black mb-5" *ngIf="!mfaRequired">Fill in the details to login into your account</p>

            <div>
              <form [formGroup]="loginform">
                <div class="mb-3" *ngIf="!mfaRequired">
                  <div class="mb-5">
                    <label for="" class="f-14 text-black font-weight-500 mb-1">Work Email ID<span class="text-danger">*</span></label>
                    <input data-testid="auto-app-signup-input-1" type="text" placeholder="Enter Email Id" class="wc-form-control nobg"
                      formControlName="emailid">

                    <p class="f-12 font-weight-500" *ngIf="loginform.get('emailid').errors?.required && (loginform['controls'].emailid.dirty || loginform['controls'].emailid.touched)"
                      [ngClass]="['text-left','my-1','text-danger']">Email Id is required</p>

                      <p class="text-danger f-12 pt-1 font-weight-500" *ngIf="loginform['controls'].emailid.hasError('pattern')">
                        Must be a valid EmailId</p>
                  </div>

                  <label class="f-14 mb-1 font-weight-500"> Password<span class="text-danger">*</span> </label>

                    <!-- <input data-testid="auto-app-signup-input-2" type="password" placeholder="Enter Password" class="wc-form-control nobg mt-1"
                      formControlName="password"> -->
                      <div class="position-relative">
                       <input data-testid="auto-app-signup-input-3" [type]="show ? 'text' : 'password'" class="wc-form-control" name="password"
                      formControlName="password" id="password" placeholder="Enter password" (keyup.enter)="!mfaRequired && logincandidate()">
                      <span class="showpassword"><i class="fas text-webbtree-green" [ngClass]="show ? 'fa-eye-slash' : 'fa-eye'"
                        (click)="show=!show"></i></span>

                    <p class="f-12 font-weight-500" *ngIf="loginform.get('password').errors?.required && (loginform['controls'].password.dirty || loginform['controls'].password.touched)"
                      [ngClass]="['text-left','my-1','text-danger']">Password is required</p>
                  </div>
                <!-- </div> -->
              </div>

                <p class="text-danger f-12 pt-1" *ngIf="invalidGLData">
                  Invalid login credentials. Try again from Admin Panel
                </p>

                <p class="text-danger f-12 pt-1 font-weight-500" *ngIf="loginError && !loginErrorMsg">
                  The email address or password you entered is incorrect</p>

                <p class="text-danger f-12 pt-1 font-weight-500" *ngIf="loginErrorMsg">
                  {{loginErrorMsg}}</p>

                <p class="text-danger f-12 pt-1 font-weight-500" *ngIf="!mfaRequired && resendWait > 0" [ngSwitch]="loginWaitCode">
                  <ng-container *ngSwitchCase="'otp_resend_limit'">No more codes can be sent. Try again in {{loginWaitText}}.</ng-container>
                  <ng-container *ngSwitchCase="'otp_locked'">Too many incorrect codes. Try again in {{loginWaitText}}.</ng-container>
                  <ng-container *ngSwitchDefault>A code was sent recently. Please try Get OTP again in {{loginWaitText}}.</ng-container>
                </p>

                  <p class="text-danger f-12 pt-1 font-weight-500" *ngIf="federatedLoginEmailNotRegistered">
                    Your Email ID is not registered. Please sign up to continue.</p>

                <p class="text-danger f-12 pt-1 font-weight-500" *ngIf="verifyEmailStatus">
                    <span *ngIf="verifyEmailStatus==2">Email Id is not verified </span>
                    <span *ngIf="verifyEmailStatus==3">Didn't received email ? </span>
                    <a data-testid="auto-app-signup-a-1" class="text-blue f-12 ml-1" (click)="resendVerficationLink()">( Resend verification email )</a>
                </p>

                <p class="text-warning f-12 pt-1" *ngIf="invalid_beta_user_msg">
                  <i class="fa-solid fa-triangle-exclamation"></i> You don’t have an active plan with Webbtree. Please reach out to <a data-testid="auto-app-signup-a-2" class="text-warning" style="text-decoration: underline; " href="mailto:customer.success@webbtree.com">customer.success&#64;webbtree.com </a> for assistance.
                </p>

                <div *ngIf="showCaptcha" class="my-3">
                  <re-captcha
                    [siteKey]="recaptchaKey"
                    (resolved)="resolvedCaptcha($event)"
                  >
                  </re-captcha>
                </div>

                  <span *ngIf="!mfaRequired" class="pointer text-bluex " routerLink="/forgetpassword">  Forgot Password ? </span>
                <div class="mt-3" *ngIf="!mfaRequired">
                  <button data-testid="auto-app-signup-button-1" type="button" class="btn wc-btn-lg f-14 font-weight-500 bgRequestBtn w-100" [ngStyle]="!enabledSignIn() ? {'background': '#ccc', 'pointer-events': 'none', 'color':'#484b59'} : {}"
                    data-dismiss="modal" (click)="logincandidate()">{{ isGhostLogin ? 'Sign In' : 'Get OTP' }}</button>
                </div>
                <div class="mt-3 text-center" *ngIf="mfaRequired && verifyingOtp">
                  <p class="f-14 font-weight-500 mb-0">Signing you in…</p>
                </div>
                <div class="mt-3" *ngIf="mfaRequired && !verifyingOtp">
                  <p class="f-12 mb-2">Enter the 6-digit code sent to <b>{{loginform.value.emailid}}</b>. It is valid for 3 minutes.</p>
                  <input data-testid="auto-app-signup-input-4" type="text" class="wc-form-control" inputmode="numeric" maxlength="6" autocomplete="one-time-code" placeholder="Verification code"
                    [value]="mfaOtp" (input)="mfaOtp = $any($event.target).value" (keyup.enter)="submitLoginOtp()" [readonly]="otpLocked">
                  <button data-testid="auto-app-signup-button-2" type="button" class="btn wc-btn-lg f-14 font-weight-500 bgRequestBtn w-100 mt-2" [disabled]="otpLocked || verifyingOtp" (click)="submitLoginOtp()">{{ verifyingOtp ? 'Signing in…' : 'Verify' }}</button>
                  <div class="d-flex justify-content-between f-12 mt-2">
                    <span *ngIf="!otpLocked && resendsLeft > 0 && resendWait > 0" class="text-muted">Resend code in {{resendWait}}s</span>
                    <a data-testid="auto-app-signup-a-3" *ngIf="!otpLocked && resendsLeft !== 0 && resendWait <= 0" class="text-blue pointer" (click)="resendLoginOtp()">Resend code</a>
                    <span *ngIf="!otpLocked && resendsLeft === 0" class="text-muted">No more codes can be sent for this sign-in</span>
                    <a data-testid="auto-app-signup-a-4" class="text-blue pointer" (click)="cancelLoginOtp()">Back</a>
                  </div>
                </div>
                <div class="row mt-4" style="text-align: center;"  *ngIf="isMobile">
                  <div class="col" [class.text-right]="!isMobile">
                      <p class="mb-1">Don't have webtree Account?&nbsp; &nbsp;</p> <button data-testid="auto-app-signup-button-3" class="wc-btn btnreset col-md-2 m-auto py-1"
                        routerLink="/signup">Sign Up</button>
                  </div>
                </div>
              </form>
            </div>
        </div>
        <div class="card-light">
          <div class="d-flex align-items-center">
            <span>
              <i class="fas fa-question-circle mr-2"></i>
            </span>
            <div>
              <p class="mb-1 font-weight-600">Need Assistance ?</p>
              <p class="mb-0 text-9696 f-12">Our team will reach out to you shortly.</p>
            </div>
          </div>
          <div>
            <button data-testid="auto-app-signup-button-4" class="wc-ghostBtn" (click)="redirect()">
              Contact Us
            </button>
          </div>
        </div>
    </div>
    </div>
    <div class="col newebbtrreebgcolor">
      <div class="sidebanner">
        <div class="textContainer">
            <div class="mb-3">
              <img src="../../assets/images/newwebbtrree.png" style="width: 155px; height: auto;" alt="">
            </div>
            <div class="talentD">
              Talent Discovery
            </div>
            <div class="beta">
              (Hire)
            </div>
            <div class="sourceenrich">
              <span>
                Source
              </span>
              <i class="fas fa-circle"></i>
              <span>
                Nurture
              </span>
              <i class="fas fa-circle"></i>

              <span>
                Engage
              </span>
              <i class="fas fa-circle"></i>

              <span>
                Strategize
              </span>
            </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- <div class="container-fluid test px-0">
  <div class="row d-flex flex-sm-row  flex-column-reverse signupmobile" [class.h-100vh]="!isMobile">
    <div class="col-md-6 bgS1 p-5 position-relative d-sm-block d-none aos-init aos-animate" data-aos="fade-up">
      <div class="row">
        <div class="col-md-8 colmd8W m-auto">
          <div class="row mb-5 d-none d-sm-block">
            <div class="col">
              <a data-testid="auto-app-signup-a-5" class="navbar-brand z2" href="https://webbtree.com/"><img src="assets/webtree.png" class="img-fluid"
                  alt="Webbtree" title="Webbtree"></a>
            </div>
          </div>
          <div class="row mb-5">
            <div class="col">
              <h1 class="f-32 font-weight-bold mb-3 text-center txt-prim">
                Source.Enrich.Nurture
              </h1>

            </div>
          </div>
          <div class="row mb-4">
            <div class="col text-center">
              <img src="assets/group-7@2x.png" class="img-fluid" alt="Search toolbox"
                title="Search toolbox">

            </div>
          </div>
          <div class="position-absolute tr0 ">
            <img src="assets/g2c3.png" alt="">
          </div>
          <div class="row">
            <div class="col text-center txt-prim">
              <p>Stay tuned for updates</p>
              <p> <span class="social-icon">
                  <a data-testid="auto-app-signup-a-6" class="" href="https://www.linkedin.com/company/webbtree/" target="_blank"><i
                      class="fab fa-linkedin f-26 linkedinColor mr-4"></i></a>
                  <a data-testid="auto-app-signup-a-7" class="" href="mailto:support@webbtree.com" target="_blank"><i
                      class="fas fa-envelope f-26 emailColor mr-4"></i></a>
                  <a data-testid="auto-app-signup-a-8" class="" href="https://www.facebook.com/webbtreeapp/" target="_blank"> <i
                      class="fab fa-facebook-square f-26 facebookColor mr-4"></i></a>

                  <a data-testid="auto-app-signup-a-9" class="" href="https://twitter.com/Webbtreeapp/" target="_blank"><i
                      class="fa-brands fa-square-x-twitter f-26 twitterColor"></i></a>
                </span></p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-6 p-5 testmobile aos-init aos-animate signup-div" data-aos="fade-up">
      <div class="row" *ngIf="signupform">
        <div class="col-md-12">
          <div class="row d-block d-sm-none">
            <div class="col">
              <img src="assets/webtree.png" class="img-fluid" alt="Webbtree" title="Webbtree">
            </div>
          </div>
          <div class="row mb-3" *ngIf="!isMobile">
            <div class="col text-right">
              <span>
                Already have an Account ? &nbsp; &nbsp;<button data-testid="auto-app-signup-button-5" class="wc-btn btnreset col-md-2 m-auto py-1"
                  routerLink="/login">Sign In</button>
              </span>
              <p> <img class="mt-4" src="assets/g2c4.png" alt=""></p>
            </div>
          </div>
          <div class="row mb-3" *ngIf="!isMobile">
            <div class="col pr-0">
              <h1 class="f-32 font-weight-bold mb-3 txt-prim">
                Sign up
              </h1>
              <p class="txt-prim" *ngIf="!teamadminemailid">
                Welcome , Let's setup your account
              </p>
              <p class="txt-prim mb-2" *ngIf="teamadminemailid">
                Welcome, You have received an invite from {{teamadminemailid}}.
              </p>
              <p *ngIf="teamadminemailid">
                Please sign up to proceed. If you are already a user, please <span class="pointer text-bluex " routerLink="/login"> Sign in</span>
              </p>
            </div>
          </div>
          <div class="row">
            <div class="col pr-sm-0">
              <form [formGroup]="candidate_form">

                <div class="row">
                  <div class="col-md-8 tcm d-flex flex-column flex-sm-row">
                      <div class="mr-5 position-relative" [class.mt-4]="isMobile">
                        <div class="googleSignIn  mb-4" #googleSignUpButton >
                        </div>
                      </div>
                  </div>
                </div>
                <p class="text-danger f-12 pt-1 mr-auto" *ngIf="alreadyExist">
                  Email ID is already registered . Please Login </p>

                <div class="row mr-2">
                  <div class="col">
                    <div class="f-12 font-weight-500 mb-3"> First Name  <span class="text-danger">*</span>
                      <input data-testid="auto-app-signup-input-5" type="text" placeholder="Enter First Name" class="wc-form-control nobg mt-1"
                        formControlName="firstName">
                      <p *ngIf="candidate_form.get('firstName').errors?.required && (candidate_form['controls'].firstName.dirty || candidate_form['controls'].firstName.touched)"
                        [ngClass]="['text-left','my-1','text-danger']">First Name is required</p>
                        <p *ngIf="candidate_form['controls'].firstName.hasError('pattern')" class="text-danger f-12 pt-1">
                          HTML tags are not allowed</p>
                    </div>
                  </div>
                  <div class="col">
                    <div class="f-12 font-weight-500 mb-3"> Last Name  <span class="text-danger">*</span>
                      <input data-testid="auto-app-signup-input-6" type="text" placeholder="Enter Last Name" class="wc-form-control nobg mt-1"
                        formControlName="lastName">
                      <p *ngIf="candidate_form.get('lastName').errors?.required && (candidate_form['controls'].lastName.dirty || candidate_form['controls'].lastName.touched)"
                        [ngClass]="['text-left','my-1','text-danger']">Last Name is required</p>
                        <p *ngIf="candidate_form['controls'].lastName.hasError('pattern')" class="text-danger f-12 pt-1">
                          HTML tags are not allowed</p>
                    </div>
                  </div>
                </div>

                <div class="row mr-2">
                  <div class="col">
                    <div class="f-12 font-weight-500 mb-3"> Work Email ID  <span class="text-danger">*</span>
                      <input data-testid="auto-app-signup-input-7" type="text" placeholder="Enter Work Email ID" class="wc-form-control nobg mt-1"
                        formControlName="workid">
                      <p *ngIf="candidate_form.get('workid').errors?.required && (candidate_form['controls'].workid.dirty || candidate_form['controls'].workid.touched)"
                        [ngClass]="['text-left','my-1','text-danger']">Work Email ID is required</p>
                      <p class="text-danger f-12 pt-1" *ngIf="candidate_form['controls'].workid.hasError('pattern')">
                        Must be a valid EmailId</p>
                    </div>
                  </div>
                  <div class="col">
                    <div class="f-12 font-weight-500 mb-3"> Phone Number  <span class="text-danger">*</span>
                      <input data-testid="auto-app-signup-input-8" type="text" placeholder="Enter Phone Number" class="wc-form-control nobg mt-1"
                        formControlName="mobileno">
                      <p *ngIf="candidate_form.get('mobileno').errors?.required && (candidate_form['controls'].mobileno.dirty || candidate_form['controls'].mobileno.touched)"
                        [ngClass]="['text-left','my-1','text-danger']">Phone Number is required</p>
                      <p class="text-danger f-12 pt-1" *ngIf="candidate_form['controls'].mobileno.hasError('pattern')">
                        Must be a valid Mobile No</p>
                    </div>
                  </div>
                </div>

                <div class="mr-4">


                  <div class="f-12 font-weight-500 mb-3"> Company  <span class="text-danger">*</span>
                    <input data-testid="auto-app-signup-input-9" type="text" placeholder="Enter Company" class="wc-form-control nobg mt-1"
                      formControlName="companyname">

                    <p *ngIf="candidate_form.get('companyname').errors?.required && (candidate_form['controls'].companyname.dirty || candidate_form['controls'].companyname.touched)"
                      [ngClass]="['text-left','my-1','text-danger']">Company Name is required</p>
                      <p *ngIf="candidate_form['controls'].companyname.hasError('pattern')" class="text-danger f-12 pt-1">
                        HTML tags are not allowed</p>
                  </div>

                  <div class="f-12 font-weight-500 mb-3"> Designation  <span class="text-danger">*</span>
                    <input data-testid="auto-app-signup-input-10" type="text" placeholder="Enter Designation" class="wc-form-control nobg mt-1"
                      formControlName="designation">

                    <p *ngIf="candidate_form.get('designation').errors?.required && (candidate_form['controls'].designation.dirty || candidate_form['controls'].designation.touched)"
                      [ngClass]="['text-left','my-1','text-danger']">Designation is required</p>
                      <p *ngIf="candidate_form['controls'].designation.hasError('pattern')" class="text-danger f-12 pt-1">
                        HTML tags are not allowed</p>
                  </div>

                  <div class="f-12 font-weight-500 mb-3"> Set Password  <span class="text-danger">*</span>
                    <input data-testid="auto-app-signup-input-11" type="password" placeholder="Enter Password" class="wc-form-control nobg mt-1"
                      formControlName="password">

                    <p *ngIf="candidate_form.get('password').errors?.required && (candidate_form['controls'].password.dirty || candidate_form['controls'].password.touched)"
                      [ngClass]="['text-left','my-1','text-danger']">Password is required</p>
                  </div>


                  <div class="f-12 font-weight-500 mb-3"> Re-type Password <span class="text-danger">*</span>
                    <input data-testid="auto-app-signup-input-12" type="password" placeholder="Re-type Password" (input)="reconfirmpwd()"
                      class="wc-form-control nobg mt-1" formControlName="confirmpwd">

                      <p *ngIf="candidate_form.get('confirmpwd').errors?.required && (candidate_form['controls'].confirmpwd.dirty || candidate_form['controls'].confirmpwd.touched)"
                      [ngClass]="['text-left','my-1','text-danger']">Confirm password is required</p>

                    <p class="text-danger f-12 pt-1"
                      *ngIf="candidate_form['controls'].confirmpwd.hasError('invalidpwd')">
                      Password Doesn't Match </p>

                  </div>

                </div>

                <div class="d-flex align-items-center mb-4 mt-1">
                  <label class="wc-checkbox mr-3 mb-0">
                    <input data-testid="auto-app-signup-input-13" type="checkbox" id="mycheck" name="mycheck" formControlName="termsaccept">
                    <i class="fas fa-check"></i>
                  </label>
                  <label class="mb-0" for="mycheck">
                    <span class="f-2"> I agree to <a data-testid="auto-app-signup-a-10" href="https://www.webbtree.com/terms-and-conditions" target="_blank" tabindex="-1">
                      Terms of Services
                    </a> and <a data-testid="auto-app-signup-a-11" href="https://www.webbtree.com/privacy-policy" target="_blank" tabindex="-1">
                      Privacy Policy
                    </a></span>
                  </label>
                </div>
                <p class="text-danger f-12 pt-1" *ngIf="termsacceptError">
                  Please Accept Terms </p>
                <button data-testid="auto-app-signup-button-6" type="button" class="btn wc-btn-lg f-14 font-weight-500 bgRequestBtn mr-4" [class.mb-4]="isMobile"
                  data-dismiss="modal" (click)="candidatesignup()">Sign Up</button>
                  <div *ngIf="isMobile" [class.mb-4]="isMobile">
                    <div class="col text-center">
                      <span style="margin-bottom: 10px;">Already have an Account ? &nbsp; &nbsp;</span><button data-testid="auto-app-signup-button-7" class="wc-btn btnreset col-md-2 m-auto py-1"
                        routerLink="/login">Sign In</button>
                    </div>
                  </div>
              </form>
            </div>
            <div class="text-right pr-3 w-65 d-none d-sm-block">
              <img src="" class="img-fluid" alt="">
            </div>
          </div>
        </div>
      </div>

      <div class="row text-center pt-100" *ngIf="confirmemailform">
        <div class="col-md-12">
          <div class="row">
            <div class="col pr-sm-0">
              <img src="assets/jointhewailtlist.png" class="img-fluid" alt="">

                <p class="font-weight-500 f-14 mt-4">
                  We’ve sent you a confirmation email
                </p>
                <p class=" f-14">
                  Click the link in your email to confirm the account.
                </p>
                <p class=" f-14">
                  If you can’t find email check your spam folder or click
                  link below to resend.
                </p>
            </div>
          </div>
          <button data-testid="auto-app-signup-button-8" type="button" class="btn wc-btn-lg f-14 font-weight-bold bgRequestBtn w-60 text-center"
            data-dismiss="modal" routerLink="/login">Back to Login</button>

            <p class="text-blue f-14 ml-1 font-weight-500 mt-4 pointer" (click)="resendVerficationLink()">Resend verification email</p>

        </div>
      </div>

      <div class="row mb-3"  *ngIf="login_form && !isMobile">
        <div class="col text-right">
          <span>
            Don't have webtree Account? &nbsp; &nbsp; <button data-testid="auto-app-signup-button-9" class="wc-btn btnreset col-md-2 m-auto py-1"
              routerLink="/signup">Sign Up</button>
          </span>
          <p> <img class="mt-4" src="assets/g2c4.png" alt=""></p>
        </div>
      </div>


      <div class="row pt-40 h-100v" *ngIf="login_form">
        <div class="col-md-12">




          <div class="row mb-3 " >
            <div class="col pr-0">
              <h1 class="f-32 font-weight-bold mb-3 txt-prim">
                Sign In
              </h1>
              <p class="f-14 txt-prim">
                Welcome back. Now get in here!
              </p>
            </div>
          </div>

          <div class="row">
            <div class="col-md-8 tcm d-flex flex-column flex-sm-row">
              <div class="mr-5 position-relative" [class.mt-4]="isMobile">
                <div class="googleSignIn  mb-4" #googleLoginButton >

                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col pr-sm-0">
              <form [formGroup]="loginform">
                <div class="mr-4 mb-3">
                  <div class="f-12 font-weight-500 mb-3"> Email Id
                    <input data-testid="auto-app-signup-input-14" type="text" placeholder="Enter Email Id" class="wc-form-control nobg mt-1"
                      formControlName="emailid">

                    <p *ngIf="loginform.get('emailid').errors?.required && (loginform['controls'].emailid.dirty || loginform['controls'].emailid.touched)"
                      [ngClass]="['text-left','my-1','text-danger']">Email Id is required</p>

                      <p class="text-danger f-12 pt-1" *ngIf="loginform['controls'].emailid.hasError('pattern')">
                        Must be a valid EmailId</p>
                  </div>

                  <span class="f-12 font-weight-500 mb-3"> Password </span>
                      <div class="position-relative">
                       <input data-testid="auto-app-signup-input-15" [type]="show ? 'text' : 'password'" class="wc-form-control" name="password"
                      formControlName="password" id="password" placeholder="Enter password" (keyup.enter)="logincandidate()">
                      <span class="showpassword"><i class="fas text-webbtree-green" [ngClass]="show ? 'fa-eye-slash' : 'fa-eye'"
                        (click)="show=!show"></i></span>

                    <p *ngIf="loginform.get('password').errors?.required && (loginform['controls'].password.dirty || loginform['controls'].password.touched)"
                      [ngClass]="['text-left','my-1','text-danger']">Password is required</p>
                  </div>
              </div>

                <p class="text-danger f-12 pt-1" *ngIf="loginError">
                  The email address or password you entered is incorrect</p>

                  <p class="text-danger f-12 pt-1" *ngIf="federatedLoginEmailNotRegistered">
                    Your Email ID is not registered. Please sign up to continue.</p>

                <p class="text-danger f-12 pt-1" *ngIf="verifyEmailStatus">
                    <span *ngIf="verifyEmailStatus==2">Email Id is not verified </span>
                    <span *ngIf="verifyEmailStatus==3">Didn't received email ? </span>
                    <a data-testid="auto-app-signup-a-12" class="text-blue f-12 ml-1" (click)="resendVerficationLink()">( Resend verification email )</a>
                </p>

                  <span class="pointer text-bluex " routerLink="/forgetpassword">  Forgot Password ? </span>
                <div class="mt-5">
                  <button data-testid="auto-app-signup-button-10" type="button" class="btn wc-btn-lg f-14 font-weight-500 bgRequestBtn  mr-4"
                    data-dismiss="modal" (click)="logincandidate()">Sign In</button>
                </div>
                <div class="row mt-4" style="text-align: center;"  *ngIf="isMobile">
                  <div class="col" [class.text-right]="!isMobile">
                      <p class="mb-1">Don't have webtree Account?&nbsp; &nbsp;</p> <button data-testid="auto-app-signup-button-11" class="wc-btn btnreset col-md-2 m-auto py-1"
                        routerLink="/signup">Sign Up</button>
                  </div>
                </div>
              </form>
            </div>
            <div class="text-right pr-3 w-65 d-none d-sm-block">
              <img src="" class="img-fluid" alt="">
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div> -->

<ngb-alert class="ngb-alert" *ngIf="successMessage" type="success"  (close)="successMessage = ''" >
  <span class="successCheck"><i class="fal fa-check"></i> </span>
 <span class="successmsg">{{ successMessage }}</span>
</ngb-alert>

<ngb-alert class="ngb-alert" *ngIf="errorMessage"   type="danger"  (close)="errorMessage = ''">
 <span class="errorCheck"><i class="fal fa-times"></i></span>
 <span class="errormsg"> {{ errorMessage }} </span>
</ngb-alert>
